import { DietSearchMealModel } from 'src/app/core/model/object/diet-model';
import { Subject } from 'rxjs';
import { PlansApiService } from './plans-api.service';
import { Injectable } from '@angular/core';
import { GenericResponse } from '../generic-response';
import { Router } from '@angular/router';
import { RouteAnimationShared } from 'src/app/utils/route-animation-shared';

@Injectable({
  providedIn: 'root',
})
export class PlansService {
  constructor(
    private plansApiService: PlansApiService,
    private router: Router,
    private routeAnimationShared: RouteAnimationShared
  ) {}
  dietID: string;
  meal: string;
  selectDay: string;
  openBottomSheet$: Subject<boolean> = new Subject<boolean>();
  closeBottomSheet$: Subject<boolean> = new Subject<boolean>();
  historyPage: number;
  setDay(day: string) {
    this.selectDay = day;
  }

  openBottomSheet(meal: string, dietID: string, date: string) {
    this.meal = meal;
    this.dietID = dietID;
    this.selectDay = date;
    this.openBottomSheet$.next(true);
  }
  closeBottomSheet() {
    this.closeBottomSheet$.next(true);
  }

  getDietsList(): Promise<GenericResponse> {
    return this.plansApiService.getDietsList();
  }
  getSuggestion(
    id: string,
    meal: string,
    page: number,
    day: string
  ): Promise<GenericResponse> {
    return this.plansApiService.getPackageSuggester(id, meal, page, day);
  }
  searchPackage(
    id: string,
    meal: string,
    foodName: string,
    day: string
  ): Promise<GenericResponse> {
    return this.plansApiService.searchPackage(id, meal, foodName, day);
  }
  goToDietTypeOverview() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/dietTypeOverview']);
  }
  AddRecentPackage(recent: DietSearchMealModel, meal: string) {
    const data = localStorage.getItem('recentPackage');
    if (data) {
      const recentPackage = JSON.parse(data);

      if (recentPackage[meal] && recentPackage[meal].length > 0) {
        const mealData = recentPackage[meal].map((meal) => meal._id);
        if (!mealData.includes(recent._id)) {
          if (mealData.length < 10) {
            localStorage.setItem(
              'recentPackage',
              `${JSON.stringify({
                ...recentPackage,
                [meal]: [...recentPackage[meal], recent],
              })}`
            );
          } else {
            recentPackage[meal].shift();
            localStorage.setItem(
              'recentPackage',
              `${JSON.stringify({
                ...recentPackage,
                [meal]: [...recentPackage[meal], recent],
              })}`
            );
          }
        }
      } else {
        localStorage.setItem(
          'recentPackage',
          `${JSON.stringify({
            ...recentPackage,
            [meal]: [recent],
          })}`
        );
      }
    } else {
      localStorage.setItem(
        'recentPackage',
        `${JSON.stringify({
          [meal]: [recent],
        })}`
      );
    }
  }
  removeRecent(id: string, meal: string) {
    const data = localStorage.getItem('recentPackage');
    if (data) {
      const recentPackage = JSON.parse(data);

      if (recentPackage[meal] && recentPackage[meal].length > 0) {
        const newRecent = recentPackage[meal].filter((f) => {
          return f._id != id;
        });
        localStorage.setItem(
          'recentPackage',
          `${JSON.stringify({
            [meal]: [...newRecent],
          })}`
        );
      }
    }
  }
  getHistory(meal: string) {
    const data = localStorage.getItem('recentPackage');
    if (data) {
      const recentPackage = JSON.parse(data);

      if (recentPackage[meal] && recentPackage[meal].length >= 1) {
        return recentPackage[meal];
      }
    }
    return null;
  }
}
